import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { PopupboxManager } from 'react-popupbox';
import Toppings from './toppings';

export default class EntreeCart extends Component {
  state = {
    entrees: '',
    error: false,
    valueOne: '',
    valueTwo: '',
    deselect: false,
    imageUrl: '',
    handle: '',
    toppings: [{}],
    one: [{}],
    protein: [{}],
    test: [{}],
  };

  componentDidMount = () => {
    const image = this.props.user.location.state.imageUrl;

    this.setState({
      imageUrl: image,
      handle: this.props.handle,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };
  handleRadioChangeOne = (event) => {
    this.setState({
      valueOne: event.target.value,
    });
  };
  handleRadioChangeTwo = (event) => {
    this.setState({
      valueTwo: event.target.value,
    });
  };

  addCart = (e, options) => {
    //lock body
    var body = document.getElementById('main-body');
    body.style.overflow = 'hidden';

    if (this.state.handle === 'Chuys') {
      this.state.protein = ['Pork', 'Chicken', 'Hibiscus'];
      // this.setState({
      //   protein:"ok"
      // })

      if (options.item === 'Taco' || options.item === 'Taco Dorado') {
        this.state.one = [
          {
            itemName: 'Corn Tortilla',
            price: 2.75,
          },
          {
            itemName: 'Flour Tortilla',
            price: 3.75,
          },
        ];

        this.state.toppings = [
          {
            name: 'Cilantro',
            price: 0.0,
          },
          {
            name: 'Onions',
            price: 0.0,
          },
          {
            name: 'Cheese',
            price: 0.0,
          },
        ];
        // this.state.one = ['Corn','Flour'];
      } else if (options.item === 'Burrito') {
        this.state.one = [
          {
            itemName: 'Flour Tortilla',
            price: 8.25,
          },
        ];
        this.state.toppings = [
          {
            name: 'Cilantro',
            price: 0.0,
          },
          {
            name: 'Onions',
            price: 0.0,
          },
          {
            name: 'Cheese',
            price: 0.0,
          },
          {
            name: 'Rice',
            price: 0.0,
          },
          {
            name: 'Beans',
            price: 0.0,
          },
        ];
      } else if (options.item === 'Mulita') {
        this.state.toppings = [
          {
            name: 'Cilantro',
            price: 0.0,
          },
          {
            name: 'Onions',
            price: 0.0,
          },
          {
            name: 'Cheese',
            price: 0.0,
          },
        ];
        this.state.one = [
          {
            itemName: 'Corn Torilla',
            price: 4.0,
          },
          {
            itemName: 'Flour Torilla',
            price: 5.0,
          },
        ];
      } else if (options.item === 'Quesi Taco') {
        this.state.toppings = [
          {
            name: 'Cilantro',
            price: 0.0,
          },
          {
            name: 'Onions',
            price: 0.0,
          },
          {
            name: 'Cheese',
            price: 0.0,
          },
        ];
        this.state.one = [
          {
            itemName: 'Corn Torilla',
            price: 3.25,
          },
          {
            itemName: 'Flour Torilla',
            price: 3.75,
          },
        ];
      }
    }

    const content = (
      <div style={{ overflowY: 'auto' }}>
        <div>
          <Paper style={{ width: '100%', padding: '25px' }}>
            <Typography variant="h5">{options.item}</Typography>
            <Divider />
          </Paper>

          <Toppings
            test={this.state.test}
            protein={this.state.protein}
            one={this.state.one}
            many={this.state.toppings}
            item={options}
          />
          {/* <Drinks /> */}
        </div>
      </div>
    );
    PopupboxManager.open({ content });
  };

  render() {
    const entrees = this.props.entrees;
    const image = this.props.imageUrl;

    return (
      <div style={{}} id="entrees">
        {entrees.map((item) => (
          <div key={item.item}>
            <Paper
              onClick={(e) => {
                this.addCart(e, item);
              }}
              style={{
                display: 'flex',
                marginBottom: 0,
                borderRadius: 0,
                width: '100%',
              }}
            >
              <Card
                style={{ display: 'flex', marginBottom: 0, borderRadius: 0 }}
              >
                <img
                  style={{
                    marginLeft: '1vw',
                    maxHeight: '64px',
                    marginTop: '4vh',
                  }}
                  src={'/foodserving.png'}
                />
                <CardContent
                  style={{ paddingBottom: '0px', minHeight: '15vh' }}
                >
                  <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                    {item.item}
                  </Typography>
                  <Typography
                    variant="body2"
                    style={{
                      color: 'rgb(118, 118, 118)',
                      fontSize: '14px',
                      fontWeight: '500',
                      lineHeight: '20px',
                      fontFamily:
                        'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                    }}
                  >
                    {item.description}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{
                      fontWeight: 500,
                      fontSize: '14px',
                      fontFamily:
                        'DD-TTNorms, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
                    }}
                  ></Typography>
                </CardContent>
              </Card>
            </Paper>

            <Divider />
          </div>
        ))}
      </div>
    );
  }
}
